import { TabulatorGrid } from './Tabulator';

function createGridApi(grid: any, ref: any) {
    return {
        dispose: () => grid?.destroyGrid(),

        updateContext: (context: any) => grid?.updateContext(context),

        updateHeaderRow: (headerRow: string) => grid?.updateHeaderRow(headerRow),

        updateHeaderColumn: (headerColumn: string) => grid?.updateHeaderColumn(headerColumn),

        setMultipleSorter: (orderdFields: any) => {
            if (grid) {
                grid.setMultipleSorter(orderdFields);
            }
        },

        setColumns: (columns: any) => grid?.setColumns(columns),

        setData: (data: any) => grid?.setData(data),

        setPivotDataSource: (data: any) => grid?.setPivotDataSource(data),

        export: (fileName: string) => grid?.export('xlsx', fileName),

        сopyDataToClipboard: () => grid?.сopyDataToClipboard(),

        resizeToParent: () => grid?.resizeToParent(),

        setSelectedRow: (index: any) => grid?.setSelectedRow(index),

        setSelectedRows: (indices: any) => grid?.setSelectedRows(indices),

        setSelectedData: (rows: any) => grid?.setSelectedData(rows),

        setIsSelecting: (isSelecting: boolean) => grid?.setIsSelecting(isSelecting),

        showNoRowsOverlay: () => grid?.showNoRowsOverlay(),

        showLoaderOverlay: () => grid?.showLoaderOverlay(),

        hideLoaderOverlay: () => grid?.hideLoaderOverlay(),

        deselectAllRows: () => grid?.deselectAllRows()
    };
}

export function createGrid(ref: any, context: any) {
    let grid = new TabulatorGrid().createGridByRef(ref, context);
    return createGridApi(grid, ref);
}
